import DashboardDeals from './DashboardDeals';

export default DashboardDeals;
